import { Provider } from '@angular/core';
import { PureAbility as Provide, createMongoAbility } from '@casl/ability';

export const PureAbilityProvider: Provider = {
  provide: Provide,
  useFactory() {
    return createMongoAbility();
  },
};
